import { useDispatch } from 'react-redux'
import { useCallback, useMemo } from 'react'

export function getPaginationHeaders(headers) {
  return {
    page: Number(headers.get('X-Page')),
    pageSize: Number(headers.get('X-Per-Page')),
    total: Number(headers.get('X-Total')),
  }
}

export function useAsyncAction(action, ...initialArgs) {
  const dispatch = useDispatch()
  // Memoize initialArgs based on their stringified value
  // This prevents the callback from being recreated when the args haven't actually changed
  const memoizedInitialArgs = useMemo(
    () => initialArgs,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(initialArgs)],
  )

  return useCallback(
    (...args) => {
      const finalArgs = args.length ? args : memoizedInitialArgs
      return dispatch(action(...finalArgs))
    },
    [action, dispatch, memoizedInitialArgs],
  )
}
